/**
 * sidebar-nav.js — <sidebar-nav> Web Component
 * Sliding drawer sidebar navigation with focus trapping and keyboard support.
 */

class SidebarNav extends HTMLElement {
  connectedCallback() {
    this._overlay = document.getElementById('sidebar-overlay');
    this._panel = document.getElementById('sidebar-panel');
    this._trigger = null;
    this._releaseFocus = null;

    document.addEventListener(Summit.events.SIDEBAR_OPEN, this._open.bind(this));
    document.addEventListener(Summit.events.SIDEBAR_CLOSE, this._close.bind(this));

    this._overlay?.addEventListener('click', this._close.bind(this));

    this._panel?.querySelectorAll('[data-sidebar-close]').forEach((btn) => {
      btn.addEventListener('click', this._close.bind(this));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._isOpen()) this._close();
    });
  }

  _isOpen() {
    return document.body.classList.contains('sidebar-nav-open');
  }

  _open(event) {
    this._trigger = event.detail?.trigger || document.querySelector('[data-sidebar-trigger]');
    document.body.classList.add('sidebar-nav-open');
    this._overlay?.removeAttribute('hidden');
    this._overlay?.removeAttribute('aria-hidden');
    this._panel?.classList.add('sidebar-nav__panel--open');
    this._panel?.removeAttribute('hidden');

    if (this._trigger) {
      this._trigger.setAttribute('aria-expanded', 'true');
    }

    if (window.SummitModal && this._panel) {
      this._releaseFocus = window.SummitModal.trapFocus(this._panel);
    }
  }

  _close() {
    document.body.classList.remove('sidebar-nav-open');
    this._overlay?.setAttribute('aria-hidden', 'true');
    this._panel?.classList.remove('sidebar-nav__panel--open');

    if (this._trigger) {
      this._trigger.setAttribute('aria-expanded', 'false');
      this._trigger = null;
    }

    if (typeof this._releaseFocus === 'function') {
      this._releaseFocus();
      this._releaseFocus = null;
    }
  }
}

customElements.define('sidebar-nav', SidebarNav);
